var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 13.125l.875-4.375-3.5-1.313L8.75.875 7.875 5.25l3.5 1.313-6.125 6.562z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 6.462a.438.438 0 00-.273-.31l-3.15-1.181.801-4.01A.437.437 0 008.43.578L2.305 7.14a.438.438 0 00.164.711L5.62 9.033l-.8 4.006a.438.438 0 00.75.383l6.125-6.563a.438.438 0 00.106-.397zm-5.82 5.24l.573-2.864a.437.437 0 00-.273-.495L3.39 7.257 8.018 2.3l-.572 2.865a.438.438 0 00.273.495l2.888 1.083-4.626 4.96z"
  })));
}
export default SvgLightning;